import { z } from "zod/v4";

import { ExclusionGroupDtoSchema } from "../../../dtos/exclusion-group";

export const GetExclusionGroupsResponseBodySchema = z.object({
  exclusionGroups: ExclusionGroupDtoSchema.array(),
});
export type GetExclusionGroupsResponseBodyType = z.infer<
  typeof GetExclusionGroupsResponseBodySchema
>;
